import styled from 'styled-components'

export const AuthorAvatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 40px;
  margin: 10px;
  margin-left: 0px;
`